import { ParallaxBackground } from "@/ui/ParallaxBackground";
import { ContentBlocks } from "src/ui/ContentBlocks";
import { SeoHead } from "src/ui/SeoHead";

import classes from "./styles.module.scss";

export default function HomePage({ prefix, title, canonical, hero, data }) {
  return (
    <>
      <SeoHead title={title} canonical={canonical} />
      <ContentBlocks data={[hero]} prefix={prefix} />
      <div className="position-relative">
        <ContentBlocks data={data} prefix={prefix} />
        <ParallaxBackground anim="y1:x2:z2n" className={classes.bg_1} />
      </div>
    </>
  );
}

export async function getStaticProps() {
  return {
    props: {
      prefix: "contact",
      title: "Contact Us",
      canonical: "/contact-us/",
      hero: {
        component: "Hero",
        props: { image: "/assets/enquiry_hero.webp", title: "Contact Us" },
      },
      data: [
        {
          component: "MultipleForms",
          props: {
            className: "pb-5 pb-lg-6",
            title: "How can we help you?",
            subtitle:
              "The personal details you input here will be used for the sole purpose of responding to your enquiry.",
            formId1: "1f92a607-4169-4a15-90a5-f12fa7e1a21f",
            formId2: "02ab2c54-4620-4e8e-aa8a-669256a4070b",
            formId3: "2ccc6932-89f8-451b-adbf-e1de3af2b650",
          },
        },
        { component: "OfficeCards", props: { title: "Our Offices" } },
      ],
    },
  };
}
